module.exports = __webpack_public_path__ + "img/available.932ced70.svg";